<template>
  <LmDialog v-model="modalShow" :styles="{ minWidth: '400px' }" title="Add New Product Type">
    <template #toolbar-actions>
      <q-btn :disabled="!productType.name" color="tertiary" size="sm" label="Save" @click="sendData(productType)" />
    </template>
    <template #content>
      <q-card-section>
        <form @submit.prevent="sendData(productType)">
          <q-input id="name" v-model.trim="productType.name" type="text" label="Type" outlined />
        </form>
      </q-card-section>
    </template>
  </LmDialog>
</template>

<script>
import { LmFormObject } from '@/lib/models/lm-form-object.class'
import { get, cloneDeep } from 'lodash'
import { mapState } from 'vuex'
// Components
import LmDialog from '@/reusable/base-components/LmDialog/LmDialog'

export default {
  name: 'FormCreateProductType',
  components: { LmDialog },
  props: {
    showing: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      modalStyle: { width: '350px', maxWidth: '350px' },
      productType: new LmFormObject({
        name: null
      })
    }
  },
  computed: {
    ...mapState({
      types: state => state.productTypes.all
    }),
    productTypeOptions() {
      return this.generateOptions({
        collection: this.types,
        excludeValue: get(this.deletable, 'id')
      })
    },
    modalShow: {
      get() {
        return this.showing
      },
      set(val) {
        !val && this.closeModal()
      }
    }
  },
  methods: {
    sendData(formData) {
      let data = cloneDeep(formData)
      delete data.errors
      delete data.originalData
      this.$store
        .dispatch('productTypes/create', {
          value: data
        })
        .then(() => {
          this.resetFormData()
          this.$emit('refresh')
          this.$emit('close')
        })
    },
    resetFormData() {
      this.productType = new LmFormObject(this.productType.originalData)
    },
    closeModal() {
      this.$emit('close')
      this.resetFormData()
    }
  }
}
</script>
